import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationAlert = _resolveComponent("ConfirmationAlert")!
  const _component_NotificationToast = _resolveComponent("NotificationToast")!
  const _component_ErrorAlertComponent = _resolveComponent("ErrorAlertComponent")!
  const _component_TermsComponent = _resolveComponent("TermsComponent")!
  const _component_OffcanvasViews = _resolveComponent("OffcanvasViews")!
  const _component_PamiaWidget = _resolveComponent("PamiaWidget")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationAlert),
    _createVNode(_component_NotificationToast),
    _createVNode(_component_ErrorAlertComponent),
    _createVNode(_component_TermsComponent),
    _createVNode(_component_OffcanvasViews),
    _createVNode(_component_PamiaWidget),
    _createVNode(_component_router_view)
  ], 64))
}